var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Service } from "@bluelibs/core";
import { XViewer } from "@bluelibs/x-ui-admin";
import { Routes } from "@bundles/UIAppBundle";
let TransactionViewer = class TransactionViewer extends XViewer {
    build() {
        const { UIComponents, router } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "_id",
                label: t("management.transactions.fields._id"),
                dataIndex: ["_id"],
                render: (value) => {
                    const props = {
                        type: "objectId",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "createdAt",
                label: t("management.transactions.fields.createdAt"),
                dataIndex: ["createdAt"],
                render: (value) => {
                    const props = {
                        type: "date",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "updatedAt",
                label: t("management.transactions.fields.updatedAt"),
                dataIndex: ["updatedAt"],
                render: (value) => {
                    const props = {
                        type: "date",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "type",
                label: t("management.transactions.fields.type"),
                dataIndex: ["type"],
                render: (value) => {
                    const props = {
                        type: "string",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "transactionDate",
                label: t("management.transactions.fields.transactionDate"),
                dataIndex: ["transactionDate"],
                render: (value) => {
                    const props = {
                        type: "date",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "transactionIdentifier",
                label: t("management.transactions.fields.transactionIdentifier"),
                dataIndex: ["transactionIdentifier"],
                render: (value) => {
                    const props = {
                        type: "string",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "dueDate",
                label: t("management.transactions.fields.dueDate"),
                dataIndex: ["dueDate"],
                render: (value) => {
                    const props = {
                        type: "date",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "amount",
                label: t("management.transactions.fields.amount"),
                dataIndex: [],
                render: (value) => {
                    var _a, _b;
                    const props = {
                        type: "number",
                        value: `${((_a = value.amount) !== null && _a !== void 0 ? _a : 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })} ${(_b = value === null || value === void 0 ? void 0 : value.sourceBankAccount) === null || _b === void 0 ? void 0 : _b.currency}`,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "isCompleted",
                label: t("management.transactions.fields.isCompleted"),
                dataIndex: ["isCompleted"],
                render: (value) => {
                    const props = {
                        type: "boolean",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "completeDate",
                label: t("management.transactions.fields.completeDate"),
                dataIndex: ["completeDate"],
                render: (value) => {
                    const props = {
                        type: "date",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "notes",
                label: t("management.transactions.fields.notes"),
                dataIndex: ["notes"],
                render: (value) => {
                    const props = {
                        type: "string",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "createdBy",
                label: t("management.transactions.fields.createdBy"),
                dataIndex: ["createdBy"],
                render: (value) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.USERS_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "fullName",
                        },
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "updatedBy",
                label: t("management.transactions.fields.updatedBy"),
                dataIndex: ["updatedBy"],
                render: (value) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.USERS_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "fullName",
                        },
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "company",
                label: t("management.transactions.fields.company"),
                dataIndex: ["company"],
                render: (value) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.COMPANIES_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "name",
                        },
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "external",
                label: t("management.transactions.fields.external"),
                dataIndex: ["external"],
                render: (value) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.EXTERNALS_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "name",
                        },
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "sourceBankAccount",
                label: t("management.transactions.fields.sourceBankAccount"),
                dataIndex: ["sourceBankAccount"],
                render: (value) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.BANK_ACCOUNTS_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "accountNumber",
                        },
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "destinationBankAccount",
                label: t("management.transactions.fields.destinationBankAccount"),
                dataIndex: ["destinationBankAccount"],
                render: (value) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.BANK_ACCOUNTS_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "accountNumber",
                        },
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "transactionFiles",
                label: t("management.transactions.fields.transactionFiles"),
                dataIndex: ["transactionFiles"],
                render: (values) => {
                    return (_jsx(_Fragment, { children: values && (_jsx("div", Object.assign({ className: "transaction-list-download-file-container" }, { children: values.map((value, idx) => {
                                return (_jsx("a", Object.assign({ href: value.downloadUrl, target: "_blank" }, { children: value.name }), idx));
                            }) }), void 0)) }, void 0));
                },
            },
        ]);
    }
    static getRequestBody() {
        return {
            _id: 1,
            createdAt: 1,
            updatedAt: 1,
            type: 1,
            transactionDate: 1,
            transactionIdentifier: 1,
            dueDate: 1,
            amount: 1,
            isCompleted: 1,
            completeDate: 1,
            notes: 1,
            initialDatas: {
                bankAccounts: {
                    sourceBankAccount: {
                        companyId: 1,
                        bankId: 1,
                        accountNumber: 1,
                        currency: 1,
                        initialBalance: 1,
                        createdAt: 1,
                        updatedAt: 1,
                        createdById: 1,
                        updatedById: 1,
                    },
                    destinationBankAccount: {
                        companyId: 1,
                        bankId: 1,
                        accountNumber: 1,
                        currency: 1,
                        initialBalance: 1,
                        createdAt: 1,
                        updatedAt: 1,
                        createdById: 1,
                        updatedById: 1,
                    },
                },
                company: {
                    name: 1,
                    email: 1,
                    phone: 1,
                    address: 1,
                    city: 1,
                    state: 1,
                    zip: 1,
                    country: 1,
                    website: 1,
                    allowedUserIds: 1,
                    createdAt: 1,
                    updatedAt: 1,
                    createdById: 1,
                    updatedById: 1,
                },
                external: {
                    name: 1,
                    email: 1,
                    phone: 1,
                    address: 1,
                    city: 1,
                    state: 1,
                    zip: 1,
                    country: 1,
                    website: 1,
                    targetBankAccount: 1,
                    targetBankName: 1,
                    type: 1,
                    responsibleUserId: 1,
                    createdAt: 1,
                    updatedAt: 1,
                    createdById: 1,
                    updatedById: 1,
                },
            },
            createdBy: {
                _id: 1,
                fullName: 1,
            },
            createdById: 1,
            updatedBy: {
                _id: 1,
                fullName: 1,
            },
            updatedById: 1,
            company: {
                _id: 1,
                name: 1,
            },
            companyId: 1,
            external: {
                _id: 1,
                name: 1,
            },
            externalId: 1,
            sourceBankAccount: {
                _id: 1,
                accountNumber: 1,
                currency: 1,
            },
            sourceBankAccountId: 1,
            destinationBankAccount: {
                _id: 1,
                accountNumber: 1,
                currency: 1,
            },
            destinationBankAccountId: 1,
            transactionFiles: {
                _id: 1,
                downloadUrl: 1,
                name: 1,
            },
            transactionFilesIds: 1,
        };
    }
};
TransactionViewer = __decorate([
    Service({ transient: true })
], TransactionViewer);
export { TransactionViewer };
